import {createContext, type ReactNode, use} from 'react'

import type {ViewDefinition} from '../../components/saved-view-options/view-definition'

const ViewDefinitionContext = createContext<ViewDefinition | null>(null)

/**
 * The view definition (aka field configuration/descriptor).  The `viewDefinition` prop is
 * required so every surface names its own definition source.
 */
export function ViewDefinitionProvider({
  viewDefinition,
  children,
}: {
  viewDefinition: ViewDefinition
  children: ReactNode
}) {
  return <ViewDefinitionContext value={viewDefinition}>{children}</ViewDefinitionContext>
}

export function useViewDefinition(): ViewDefinition {
  const viewDefinition = use(ViewDefinitionContext)
  if (viewDefinition === null) {
    throw new Error('useViewDefinition must be used within <ViewDefinitionProvider>')
  }
  return viewDefinition
}
